import http from '../api/http'

export default {
  all: () => http.get('/tags/all'),
  allByType: (type, conditions = []) => http.get('/tags/all-by-type', { params: { type, conditions } }),
  list: () => http.get('/tags/list'),
  listByType: (type) => http.get('/tags/list-by-type', { params: { type } })
}



// WEBPACK FOOTER //
// ./src/services/tags.js